import React from 'react';
import { View, StyleSheet } from 'react-native';
import { LogsView, MigrateView } from './admin';
import { EDITOR_COLORS } from '../../styles/editorTheme';

interface ProGroupsAdminViewProps {
  storage?: any;
  apiService?: any;
  initialSubsection?: string;
}

type AdminSubsection = 'Logs' | 'Migrate';

const resolveAdminSubsection = (initialSubsection?: string): AdminSubsection => {
  switch (initialSubsection) {
    case 'Logs':
    case 'Migrate':
      return initialSubsection;
    default:
      return 'Logs';
  }
};

export const ProGroupsAdminView: React.FC<ProGroupsAdminViewProps> = ({
  storage,
  apiService,
  initialSubsection,
}) => {
  const activeSubsection = resolveAdminSubsection(initialSubsection);

  return (
    <View style={styles.container}>
      {activeSubsection === 'Logs' ? (
        <LogsView />
      ) : (
        <MigrateView apiService={apiService} storage={storage} />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: EDITOR_COLORS.background,
  },
});
